import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useSessionQuery, useTokenMutation } from '@/api/sessions';

const Authenticated = () => {
  const { isSuccess, isError, isLoading } = useSessionQuery();
  const [token] = useTokenMutation();

  useEffect(() => {
    if (!isLoading && isError) {
      if (import.meta.env.MODE === 'development') {
        token();
      } else {
        localStorage.setItem(
          'kinesis:redirect',
          `${window.location.pathname}${window.location.search}`,
        );
        window.location.assign('/');
      }
    }
  }, [isError, isLoading, token]);

  if (!isLoading && isSuccess) {
    return <Outlet />;
  }

  return null;
};

export { Authenticated };
